import React from 'react';
import { useTranslations } from '@lang';
import { useRouter } from 'shared-routing';
import { Routes } from '@common/constants';
import { TextWithIcon } from '@common/components/Typography';
import { UserIcon } from '@root/styles/icons';
import { Guest } from '@root/../shared-types/Common';
import { ActionButton, StyledLink } from '../../../GeneralLayout.styles';
import { SignInContainer } from './SignIn.styles';

export type SignInProps = {
  guest: Guest | null;
};

export const SignIn: React.FC<SignInProps> = ({ guest }) => {
  const { t } = useTranslations();
  const router = useRouter();
  const isLoggedIn = !!guest;

  return (
    <SignInContainer>
      {isLoggedIn ? (
        <StyledLink route={Routes.MY_ACCOUNT}>
          <ActionButton>
            <UserIcon />
            {t('common.myAccount')}
          </ActionButton>
        </StyledLink>
      ) : (
        <StyledLink route={Routes.SIGNIN} params={{ redirectTo: router.asPath }}>
          <ActionButton>
            <TextWithIcon icon={<UserIcon />} textId="signIn.label" />
          </ActionButton>
        </StyledLink>
      )}
    </SignInContainer>
  );
};
